import { createAppKit } from '@reown/appkit/react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { bsc, bscTestnet } from 'wagmi/chains';

// Setup queryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
    },
  },
});

// Get project ID from environment
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;

// Set the networks
const networks = [bsc];

// Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true,
});

// Create AppKit with proper configuration
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata: {
    name: 'Bomberman Game',
    description: 'Multiplayer Bomberman Game with Blockchain Integration',
    url: typeof window !== 'undefined' ? window.location.origin : 'https://localhost:5173',
    icons: ['https://avatars.githubusercontent.com/u/179229932'],
  },
  // features: {
  //   email: true, // Enable email login
  //   socials: ['google', 'x', 'github'], // Social login options
  //   emailShowWallets: true, // Show wallet options with email
  //   analytics: true, // Optional - defaults to your Cloud configuration
  // },
  themeMode: 'dark', // Match your game's dark theme
  themeVariables: {
    '--w3m-accent': '#3b82f6', // Blue accent
    '--w3m-border-radius-master': '12px',
  },
  defaultNetwork: bscTestnet, // BSC Testnet as default
});

export function AppKitProvider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}

export default AppKitProvider;
